<template>
    <CodiceFeanorView tool-module="base64" />
</template>

<script setup>
import CodiceFeanorView from "../CodiceFeanorView.vue";
</script>
